<template>
  <v-card
    class="mt-1"
    height="auto"
  >
    <iframe
      v-if="iframe"
      :src="iframe.src"
      :style="iframe.style"
      :height="iframe.height"
      :width="iframe.width"
      type="application/pdf"
      frameborder="0"
    />
  </v-card>
</template>

<script>
  export default {
    name: 'Print',
    data: () => ({
      iframe: null,
      load: false,
    }),
    mounted () {
      this.iframe = {
        src: 'http://' + JSON.parse(localStorage.getItem('token')).init.HTTP_HOST + '/invoice/view?id=' + this.$route.params.id,
        style: null,
        height: 400,
        width: '100%',
      }
      this.load = true
    },
  }
</script>

<style scoped>

</style>
